import { useTranslation } from 'react-i18next'

import { Field, FieldContent, FieldLabel } from '@/shared/components/ui/field'
import {
	MultiSelect,
	MultiSelectContent,
	MultiSelectGroup,
	MultiSelectItem,
	MultiSelectList,
	MultiSelectSearch,
	MultiSelectTrigger,
	MultiSelectValue,
} from '@/shared/components/ui/multi-select'
import { Skeleton } from '@/shared/components/ui/skeleton'

import { useScenariosOptions } from '../lib/useScneriosOptions'

export const OptimizationGroupScenariosSelect = ({
	optimizationGroupId,
	values,
	onValueChange,
}: {
	optimizationGroupId: string
	values: string[]
	onValueChange: (ids: string[], ogId: string) => void
}) => {
	const { t } = useTranslation()

	const { options, optimizationGroupName, isLoading } =
		useScenariosOptions(optimizationGroupId)

	return isLoading ? (
		<Loader />
	) : (
		<Field className='grid'>
			<FieldLabel htmlFor={optimizationGroupId} className='text-default'>
				{optimizationGroupName}
			</FieldLabel>
			<FieldContent className='overflow-auto'>
				<MultiSelect
					isLoading={isLoading}
					options={options}
					value={values}
					onValueChange={(newValues) =>
						onValueChange(newValues, optimizationGroupId)
					}
				>
					<MultiSelectTrigger className='w-full'>
						<MultiSelectValue
							id={optimizationGroupId}
							maxDisplay={7}
							placeholder={t('general_select')}
						/>
					</MultiSelectTrigger>
					<MultiSelectContent>
						<MultiSelectSearch placeholder={t('general_search')} />
						<MultiSelectList>
							<MultiSelectGroup>
								{options?.map((option) => (
									<MultiSelectItem key={option.value} value={option.value}>
										{option.label}
									</MultiSelectItem>
								))}
							</MultiSelectGroup>
						</MultiSelectList>
					</MultiSelectContent>
				</MultiSelect>
			</FieldContent>
		</Field>
	)
}
const Loader = () => (
	<div className='space-y-1'>
		<Skeleton className='h-6 w-full' />
		<Skeleton className='h-9 w-full' />
	</div>
)
